define(function (require) {
    "use strict";

    var LE = require("app");
    var ROLES_BY_IDS = require("user-management-assets/data/roles.json");

    var ProfilesFilters = [];

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        ProfilesFilters = [
            {
                name: "profileName",
                type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

                getFilterData: function () {
                    var dataManager = LEUserManagement.getDataManager();

                    var profilesCollection = dataManager.getData(dataManager.getEntities().PROFILES);
                    var privileges = {viewAll:LEUserManagement.hasAllProfilesViewPrivilege(), editAgentProfile: LEUserManagement.hasAgentProfileEditPrivilege(), editAgentManagerProfile: LEUserManagement.hasAgentManagerProfileEditPrivilege()};

                    var valuesArr = [];
                    profilesCollection.each(function (profileModel) {
                        if (profileModel.isViewableForLoggedInUser(privileges)) {
                            valuesArr.push({id: profileModel.getName(), value: profileModel.getName()});
                        }
                    });
                    return {
                        valuesArr: valuesArr,
                        placeholderText: LE.translator.translate("LEUserManagement.profileList.column.profileName.filter.placeholder")
                    };
                }
            },
            {
                name: "role",
                type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

                getFilterData: function () {
                    var dataManager = LEUserManagement.getDataManager();

                    var profilesCollection = dataManager.getData(dataManager.getEntities().PROFILES);
                    var privileges = {viewAll:LEUserManagement.hasAllProfilesViewPrivilege(), editAgentProfile: LEUserManagement.hasAgentProfileEditPrivilege(), editAgentManagerProfile: LEUserManagement.hasAgentManagerProfileEditPrivilege()};

                    var valuesArr = [];
                    profilesCollection.each(function (profileModel) {
                        if (profileModel.isViewableForLoggedInUser(privileges)) {
                            valuesArr.push({
                                id: profileModel.getRoleTypeId(),
                                value: LE.translator.translate(ROLES_BY_IDS["" + profileModel.getRoleTypeId()])
                            });
                        }
                    });
                    return {
                        valuesArr: valuesArr,
                        placeholderText: LE.translator.translate("LEUserManagement.profileList.column.role.filter.placeholder")
                    };
                }
            }];
    }

    LE.module("LEUserManagement", moduleDefinition);

    return ProfilesFilters;
});

//


